// source: api/organization.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var primitive_proto_pb = require('../primitive_proto_pb.js');
goog.object.extend(proto, primitive_proto_pb);
var device_record_proto_pb = require('../device_record_proto_pb.js');
goog.object.extend(proto, device_record_proto_pb);
var identity_record_proto_pb = require('../identity_record_proto_pb.js');
goog.object.extend(proto, identity_record_proto_pb);
var integration_proto_pb = require('../integration_proto_pb.js');
goog.object.extend(proto, integration_proto_pb);
var organization_membership_proto_pb = require('../organization_membership_proto_pb.js');
goog.object.extend(proto, organization_membership_proto_pb);
var organization_role_proto_pb = require('../organization_role_proto_pb.js');
goog.object.extend(proto, organization_role_proto_pb);
var organization_proto_pb = require('../organization_proto_pb.js');
goog.object.extend(proto, organization_proto_pb);
var style_proto_pb = require('../style_proto_pb.js');
goog.object.extend(proto, style_proto_pb);
var user_proto_pb = require('../user_proto_pb.js');
goog.object.extend(proto, user_proto_pb);
var license_proto_pb = require('../license_proto_pb.js');
goog.object.extend(proto, license_proto_pb);
var feature_proto_pb = require('../feature_proto_pb.js');
goog.object.extend(proto, feature_proto_pb);
var api_workspace_pb = require('../api/workspace_pb.js');
goog.object.extend(proto, api_workspace_pb);
var api_device_pb = require('../api/device_pb.js');
goog.object.extend(proto, api_device_pb);
var api_client_record_proto_pb = require('../api_client_record_proto_pb.js');
goog.object.extend(proto, api_client_record_proto_pb);
var timestamp_proto_pb = require('../timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.somewear.api.v1.ClaimOrganizationRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateBeamAuthRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationApiClientRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationApiClientResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationIntegrationRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationIntegrationResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationResourceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationResourceResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationTakServerRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationWorkspaceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateOrganizationWorkspaceResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeleteOrganizationApiClientRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeleteOrganizationApiClientResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationApiClientsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationApiClientsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationBillingInfoRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationBillingInfoResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationDeviceUsageRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationDevicesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIdentitiesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIdentitiesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationIntegrationsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationResourcesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationResourcesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationWorkspacesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetOrganizationWorkspacesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.InviteOrganizationMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.InviteOrganizationMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.JoinOrganizationWorkspaceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveOrganizationIntegrationRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveOrganizationIntegrationResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveOrganizationMembersRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.RemoveOrganizationMembersResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.SendCotToTakServerRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.SendCotToTakServerResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationRoleRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UpdateOrganizationRoleResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.displayName = 'proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.displayName = 'proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationWorkspacesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationWorkspacesRequest.displayName = 'proto.somewear.api.v1.GetOrganizationWorkspacesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationWorkspacesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationWorkspacesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationWorkspacesResponse.displayName = 'proto.somewear.api.v1.GetOrganizationWorkspacesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.displayName = 'proto.somewear.api.v1.CreateOrganizationWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationWorkspaceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.displayName = 'proto.somewear.api.v1.CreateOrganizationWorkspaceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIdentitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIdentitiesRequest.displayName = 'proto.somewear.api.v1.GetOrganizationIdentitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationIdentitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIdentitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIdentitiesResponse.displayName = 'proto.somewear.api.v1.GetOrganizationIdentitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationMembersRequest.displayName = 'proto.somewear.api.v1.GetOrganizationMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationMembersResponse.displayName = 'proto.somewear.api.v1.GetOrganizationMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationResourcesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationResourcesRequest.displayName = 'proto.somewear.api.v1.GetOrganizationResourcesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationResourcesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationResourcesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationResourcesResponse.displayName = 'proto.somewear.api.v1.GetOrganizationResourcesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationDevicesRequest.displayName = 'proto.somewear.api.v1.GetOrganizationDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationDevicesResponse.displayName = 'proto.somewear.api.v1.GetOrganizationDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationsRequest.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationIntegrationsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationsResponse.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationBillingInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationBillingInfoRequest.displayName = 'proto.somewear.api.v1.GetOrganizationBillingInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationBillingInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationBillingInfoResponse.displayName = 'proto.somewear.api.v1.GetOrganizationBillingInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationRoleRequest.displayName = 'proto.somewear.api.v1.UpdateOrganizationRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationRoleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationRoleResponse.displayName = 'proto.somewear.api.v1.UpdateOrganizationRoleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.InviteOrganizationMembersRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.InviteOrganizationMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.InviteOrganizationMembersRequest.displayName = 'proto.somewear.api.v1.InviteOrganizationMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.InviteOrganizationMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.InviteOrganizationMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.InviteOrganizationMembersResponse.displayName = 'proto.somewear.api.v1.InviteOrganizationMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.RemoveOrganizationMembersRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.RemoveOrganizationMembersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveOrganizationMembersRequest.displayName = 'proto.somewear.api.v1.RemoveOrganizationMembersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.RemoveOrganizationMembersResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.RemoveOrganizationMembersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveOrganizationMembersResponse.displayName = 'proto.somewear.api.v1.RemoveOrganizationMembersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.JoinOrganizationWorkspaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.displayName = 'proto.somewear.api.v1.JoinOrganizationWorkspaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationDeviceUsageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.displayName = 'proto.somewear.api.v1.GetOrganizationDeviceUsageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.displayName = 'proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.displayName = 'proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationTakServerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationTakServerRequest.displayName = 'proto.somewear.api.v1.CreateOrganizationTakServerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateBeamAuthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateBeamAuthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateBeamAuthRequest.displayName = 'proto.somewear.api.v1.CreateBeamAuthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationIntegrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationIntegrationRequest.displayName = 'proto.somewear.api.v1.CreateOrganizationIntegrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationIntegrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationIntegrationResponse.displayName = 'proto.somewear.api.v1.CreateOrganizationIntegrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.RemoveOrganizationIntegrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.displayName = 'proto.somewear.api.v1.RemoveOrganizationIntegrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.RemoveOrganizationIntegrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.displayName = 'proto.somewear.api.v1.RemoveOrganizationIntegrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationResourceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationResourceRequest.displayName = 'proto.somewear.api.v1.CreateOrganizationResourceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationResourceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationResourceResponse.displayName = 'proto.somewear.api.v1.CreateOrganizationResourceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationApiClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationApiClientRequest.displayName = 'proto.somewear.api.v1.CreateOrganizationApiClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateOrganizationApiClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateOrganizationApiClientResponse.displayName = 'proto.somewear.api.v1.CreateOrganizationApiClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeleteOrganizationApiClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeleteOrganizationApiClientRequest.displayName = 'proto.somewear.api.v1.DeleteOrganizationApiClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeleteOrganizationApiClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeleteOrganizationApiClientResponse.displayName = 'proto.somewear.api.v1.DeleteOrganizationApiClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationApiClientsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationApiClientsRequest.displayName = 'proto.somewear.api.v1.GetOrganizationApiClientsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationApiClientsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationApiClientsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationApiClientsResponse.displayName = 'proto.somewear.api.v1.GetOrganizationApiClientsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.displayName = 'proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.displayName = 'proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.displayName = 'proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.displayName = 'proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.displayName = 'proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.displayName = 'proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.displayName = 'proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ClaimOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ClaimOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ClaimOrganizationRequest.displayName = 'proto.somewear.api.v1.ClaimOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.SendCotToTakServerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.SendCotToTakServerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.SendCotToTakServerRequest.displayName = 'proto.somewear.api.v1.SendCotToTakServerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.SendCotToTakServerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.SendCotToTakServerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.SendCotToTakServerResponse.displayName = 'proto.somewear.api.v1.SendCotToTakServerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.displayName = 'proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.displayName = 'proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest;
  return proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
licenseSummary: (f = msg.getLicenseSummary()) && license_proto_pb.LicenseSummary.toObject(includeInstance, f),
licenseUsage: (f = msg.getLicenseUsage()) && license_proto_pb.LicenseUsageNotification.toObject(includeInstance, f),
capabilitiesList: jspb.Message.toObjectList(msg.getCapabilitiesList(),
    feature_proto_pb.OrganizationCapability.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse;
  return proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new license_proto_pb.LicenseSummary;
      reader.readMessage(value,license_proto_pb.LicenseSummary.deserializeBinaryFromReader);
      msg.setLicenseSummary(value);
      break;
    case 2:
      var value = new license_proto_pb.LicenseUsageNotification;
      reader.readMessage(value,license_proto_pb.LicenseUsageNotification.deserializeBinaryFromReader);
      msg.setLicenseUsage(value);
      break;
    case 3:
      var value = new feature_proto_pb.OrganizationCapability;
      reader.readMessage(value,feature_proto_pb.OrganizationCapability.deserializeBinaryFromReader);
      msg.addCapabilities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLicenseSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      license_proto_pb.LicenseSummary.serializeBinaryToWriter
    );
  }
  f = message.getLicenseUsage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      license_proto_pb.LicenseUsageNotification.serializeBinaryToWriter
    );
  }
  f = message.getCapabilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      feature_proto_pb.OrganizationCapability.serializeBinaryToWriter
    );
  }
};


/**
 * optional LicenseSummary license_summary = 1;
 * @return {?proto.LicenseSummary}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.getLicenseSummary = function() {
  return /** @type{?proto.LicenseSummary} */ (
    jspb.Message.getWrapperField(this, license_proto_pb.LicenseSummary, 1));
};


/**
 * @param {?proto.LicenseSummary|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.setLicenseSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.clearLicenseSummary = function() {
  return this.setLicenseSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.hasLicenseSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LicenseUsageNotification license_usage = 2;
 * @return {?proto.LicenseUsageNotification}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.getLicenseUsage = function() {
  return /** @type{?proto.LicenseUsageNotification} */ (
    jspb.Message.getWrapperField(this, license_proto_pb.LicenseUsageNotification, 2));
};


/**
 * @param {?proto.LicenseUsageNotification|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.setLicenseUsage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.clearLicenseUsage = function() {
  return this.setLicenseUsage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.hasLicenseUsage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OrganizationCapability capabilities = 3;
 * @return {!Array<!proto.OrganizationCapability>}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.getCapabilitiesList = function() {
  return /** @type{!Array<!proto.OrganizationCapability>} */ (
    jspb.Message.getRepeatedWrapperField(this, feature_proto_pb.OrganizationCapability, 3));
};


/**
 * @param {!Array<!proto.OrganizationCapability>} value
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.setCapabilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.OrganizationCapability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.OrganizationCapability}
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.addCapabilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.OrganizationCapability, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationLicenseSummaryResponse.prototype.clearCapabilitiesList = function() {
  return this.setCapabilitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationWorkspacesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
includeArchived: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationWorkspacesRequest;
  return proto.somewear.api.v1.GetOrganizationWorkspacesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationWorkspacesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeArchived();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool include_archived = 1;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.prototype.getIncludeArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesRequest} returns this
 */
proto.somewear.api.v1.GetOrganizationWorkspacesRequest.prototype.setIncludeArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationWorkspacesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspacesList: jspb.Message.toObjectList(msg.getWorkspacesList(),
    user_proto_pb.WorkspaceResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationWorkspacesResponse;
  return proto.somewear.api.v1.GetOrganizationWorkspacesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.WorkspaceResponse;
      reader.readMessage(value,user_proto_pb.WorkspaceResponse.deserializeBinaryFromReader);
      msg.addWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationWorkspacesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspacesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      user_proto_pb.WorkspaceResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WorkspaceResponse workspaces = 1;
 * @return {!Array<!proto.WorkspaceResponse>}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.getWorkspacesList = function() {
  return /** @type{!Array<!proto.WorkspaceResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, user_proto_pb.WorkspaceResponse, 1));
};


/**
 * @param {!Array<!proto.WorkspaceResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.setWorkspacesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.WorkspaceResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.WorkspaceResponse}
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.addWorkspaces = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.WorkspaceResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationWorkspacesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationWorkspacesResponse.prototype.clearWorkspacesList = function() {
  return this.setWorkspacesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
addSelfAsMember: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
styleSettings: (f = msg.getStyleSettings()) && style_proto_pb.StyleSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationWorkspaceRequest;
  return proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddSelfAsMember(value);
      break;
    case 3:
      var value = new style_proto_pb.StyleSettings;
      reader.readMessage(value,style_proto_pb.StyleSettings.deserializeBinaryFromReader);
      msg.setStyleSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddSelfAsMember();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStyleSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      style_proto_pb.StyleSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool add_self_as_member = 2;
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.getAddSelfAsMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.setAddSelfAsMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional StyleSettings style_settings = 3;
 * @return {?proto.StyleSettings}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.getStyleSettings = function() {
  return /** @type{?proto.StyleSettings} */ (
    jspb.Message.getWrapperField(this, style_proto_pb.StyleSettings, 3));
};


/**
 * @param {?proto.StyleSettings|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} returns this
*/
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.setStyleSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.clearStyleSettings = function() {
  return this.setStyleSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceRequest.prototype.hasStyleSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workspace: (f = msg.getWorkspace()) && user_proto_pb.WorkspaceResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationWorkspaceResponse;
  return proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.WorkspaceResponse;
      reader.readMessage(value,user_proto_pb.WorkspaceResponse.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.WorkspaceResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkspaceResponse workspace = 1;
 * @return {?proto.WorkspaceResponse}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.getWorkspace = function() {
  return /** @type{?proto.WorkspaceResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.WorkspaceResponse, 1));
};


/**
 * @param {?proto.WorkspaceResponse|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse} returns this
*/
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationWorkspaceResponse} returns this
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationWorkspaceResponse.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIdentitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesRequest}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIdentitiesRequest;
  return proto.somewear.api.v1.GetOrganizationIdentitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesRequest}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIdentitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIdentitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIdentitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
identitiesList: jspb.Message.toObjectList(msg.getIdentitiesList(),
    identity_record_proto_pb.IdentityRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIdentitiesResponse;
  return proto.somewear.api.v1.GetOrganizationIdentitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.addIdentities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIdentitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IdentityRecord identities = 1;
 * @return {!Array<!proto.IdentityRecord>}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.getIdentitiesList = function() {
  return /** @type{!Array<!proto.IdentityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {!Array<!proto.IdentityRecord>} value
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.setIdentitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.IdentityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IdentityRecord}
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.addIdentities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.IdentityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationIdentitiesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationIdentitiesResponse.prototype.clearIdentitiesList = function() {
  return this.setIdentitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationMembersRequest}
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationMembersRequest;
  return proto.somewear.api.v1.GetOrganizationMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationMembersRequest}
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    organization_membership_proto_pb.OrganizationMemberResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationMembersResponse}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationMembersResponse;
  return proto.somewear.api.v1.GetOrganizationMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationMembersResponse}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMemberResponse;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMemberResponse.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMemberResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrganizationMemberResponse members = 1;
 * @return {!Array<!proto.OrganizationMemberResponse>}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.OrganizationMemberResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, organization_membership_proto_pb.OrganizationMemberResponse, 1));
};


/**
 * @param {!Array<!proto.OrganizationMemberResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationMembersResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.OrganizationMemberResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.OrganizationMemberResponse}
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.OrganizationMemberResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationMembersResponse.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationResourcesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesRequest}
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationResourcesRequest;
  return proto.somewear.api.v1.GetOrganizationResourcesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesRequest}
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationResourcesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationResourcesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationResourcesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resourcesList: jspb.Message.toObjectList(msg.getResourcesList(),
    identity_record_proto_pb.IdentityRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesResponse}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationResourcesResponse;
  return proto.somewear.api.v1.GetOrganizationResourcesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesResponse}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.addResources(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationResourcesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationResourcesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IdentityRecord resources = 1;
 * @return {!Array<!proto.IdentityRecord>}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.getResourcesList = function() {
  return /** @type{!Array<!proto.IdentityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {!Array<!proto.IdentityRecord>} value
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.setResourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.IdentityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IdentityRecord}
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.addResources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.IdentityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationResourcesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationResourcesResponse.prototype.clearResourcesList = function() {
  return this.setResourcesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
includeDevicePlans: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesRequest}
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationDevicesRequest;
  return proto.somewear.api.v1.GetOrganizationDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesRequest}
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDevicePlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeDevicePlans();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool include_device_plans = 1;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.prototype.getIncludeDevicePlans = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesRequest} returns this
 */
proto.somewear.api.v1.GetOrganizationDevicesRequest.prototype.setIncludeDevicePlans = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    device_record_proto_pb.DeviceRecord.toObject, includeInstance),
plansList: jspb.Message.toObjectList(msg.getPlansList(),
    api_device_pb.DevicePlanResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationDevicesResponse;
  return proto.somewear.api.v1.GetOrganizationDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    case 2:
      var value = new api_device_pb.DevicePlanResponse;
      reader.readMessage(value,api_device_pb.DevicePlanResponse.deserializeBinaryFromReader);
      msg.addPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
  f = message.getPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      api_device_pb.DevicePlanResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceRecord devices = 1;
 * @return {!Array<!proto.DeviceRecord>}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.DeviceRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {!Array<!proto.DeviceRecord>} value
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceRecord}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};


/**
 * repeated DevicePlanResponse plans = 2;
 * @return {!Array<!proto.somewear.api.v1.DevicePlanResponse>}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.getPlansList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.DevicePlanResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, api_device_pb.DevicePlanResponse, 2));
};


/**
 * @param {!Array<!proto.somewear.api.v1.DevicePlanResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.setPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.somewear.api.v1.DevicePlanResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.DevicePlanResponse}
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.addPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.somewear.api.v1.DevicePlanResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationDevicesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationDevicesResponse.prototype.clearPlansList = function() {
  return this.setPlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsRequest}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationsRequest;
  return proto.somewear.api.v1.GetOrganizationIntegrationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsRequest}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
integrationsOldList: jspb.Message.toObjectList(msg.getIntegrationsOldList(),
    organization_membership_proto_pb.OrganizationMemberResponse.toObject, includeInstance),
integrationsList: jspb.Message.toObjectList(msg.getIntegrationsList(),
    integration_proto_pb.IntegrationResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationsResponse;
  return proto.somewear.api.v1.GetOrganizationIntegrationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMemberResponse;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMemberResponse.deserializeBinaryFromReader);
      msg.addIntegrationsOld(value);
      break;
    case 2:
      var value = new integration_proto_pb.IntegrationResponse;
      reader.readMessage(value,integration_proto_pb.IntegrationResponse.deserializeBinaryFromReader);
      msg.addIntegrations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegrationsOldList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMemberResponse.serializeBinaryToWriter
    );
  }
  f = message.getIntegrationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      integration_proto_pb.IntegrationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrganizationMemberResponse integrations_old = 1;
 * @return {!Array<!proto.OrganizationMemberResponse>}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.getIntegrationsOldList = function() {
  return /** @type{!Array<!proto.OrganizationMemberResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, organization_membership_proto_pb.OrganizationMemberResponse, 1));
};


/**
 * @param {!Array<!proto.OrganizationMemberResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.setIntegrationsOldList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.OrganizationMemberResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.OrganizationMemberResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.addIntegrationsOld = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.OrganizationMemberResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.clearIntegrationsOldList = function() {
  return this.setIntegrationsOldList([]);
};


/**
 * repeated IntegrationResponse integrations = 2;
 * @return {!Array<!proto.IntegrationResponse>}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.getIntegrationsList = function() {
  return /** @type{!Array<!proto.IntegrationResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, integration_proto_pb.IntegrationResponse, 2));
};


/**
 * @param {!Array<!proto.IntegrationResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.setIntegrationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.IntegrationResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IntegrationResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.addIntegrations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.IntegrationResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationsResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationsResponse.prototype.clearIntegrationsList = function() {
  return this.setIntegrationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationBillingInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoRequest}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationBillingInfoRequest;
  return proto.somewear.api.v1.GetOrganizationBillingInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoRequest}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationBillingInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationBillingInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationBillingInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hostedEditBillingUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
recurlySettings: (f = msg.getRecurlySettings()) && organization_proto_pb.OrganizationRecurlySettingsRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationBillingInfoResponse;
  return proto.somewear.api.v1.GetOrganizationBillingInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostedEditBillingUrl(value);
      break;
    case 2:
      var value = new organization_proto_pb.OrganizationRecurlySettingsRecord;
      reader.readMessage(value,organization_proto_pb.OrganizationRecurlySettingsRecord.deserializeBinaryFromReader);
      msg.setRecurlySettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationBillingInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostedEditBillingUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecurlySettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      organization_proto_pb.OrganizationRecurlySettingsRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional string hosted_edit_billing_url = 1;
 * @return {string}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.getHostedEditBillingUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.setHostedEditBillingUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrganizationRecurlySettingsRecord recurly_settings = 2;
 * @return {?proto.OrganizationRecurlySettingsRecord}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.getRecurlySettings = function() {
  return /** @type{?proto.OrganizationRecurlySettingsRecord} */ (
    jspb.Message.getWrapperField(this, organization_proto_pb.OrganizationRecurlySettingsRecord, 2));
};


/**
 * @param {?proto.OrganizationRecurlySettingsRecord|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.setRecurlySettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationBillingInfoResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.clearRecurlySettings = function() {
  return this.setRecurlySettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationBillingInfoResponse.prototype.hasRecurlySettings = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
role: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleRequest}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationRoleRequest;
  return proto.somewear.api.v1.UpdateOrganizationRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleRequest}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {!proto.OrganizationRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrganizationRole role = 2;
 * @return {!proto.OrganizationRole}
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.getRole = function() {
  return /** @type {!proto.OrganizationRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.OrganizationRole} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationRoleRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationRoleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
member: (f = msg.getMember()) && organization_membership_proto_pb.OrganizationMemberResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleResponse}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationRoleResponse;
  return proto.somewear.api.v1.UpdateOrganizationRoleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleResponse}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMemberResponse;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMemberResponse.deserializeBinaryFromReader);
      msg.setMember(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationRoleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationRoleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMember();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMemberResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationMemberResponse member = 1;
 * @return {?proto.OrganizationMemberResponse}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.getMember = function() {
  return /** @type{?proto.OrganizationMemberResponse} */ (
    jspb.Message.getWrapperField(this, organization_membership_proto_pb.OrganizationMemberResponse, 1));
};


/**
 * @param {?proto.OrganizationMemberResponse|undefined} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleResponse} returns this
*/
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.setMember = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.UpdateOrganizationRoleResponse} returns this
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.clearMember = function() {
  return this.setMember(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.UpdateOrganizationRoleResponse.prototype.hasMember = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.InviteOrganizationMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityRecordsList: jspb.Message.toObjectList(msg.getIdentityRecordsList(),
    identity_record_proto_pb.IdentityRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersRequest}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.InviteOrganizationMembersRequest;
  return proto.somewear.api.v1.InviteOrganizationMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersRequest}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.addIdentityRecords(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.InviteOrganizationMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IdentityRecord identity_records = 1;
 * @return {!Array<!proto.IdentityRecord>}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.getIdentityRecordsList = function() {
  return /** @type{!Array<!proto.IdentityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {!Array<!proto.IdentityRecord>} value
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersRequest} returns this
*/
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.setIdentityRecordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.IdentityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IdentityRecord}
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.addIdentityRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.IdentityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersRequest} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersRequest.prototype.clearIdentityRecordsList = function() {
  return this.setIdentityRecordsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.InviteOrganizationMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membershipsList: jspb.Message.toObjectList(msg.getMembershipsList(),
    organization_membership_proto_pb.OrganizationMembershipRecord.toObject, includeInstance),
identityRecordsList: jspb.Message.toObjectList(msg.getIdentityRecordsList(),
    identity_record_proto_pb.IdentityRecord.toObject, includeInstance),
failedIdentityIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.InviteOrganizationMembersResponse;
  return proto.somewear.api.v1.InviteOrganizationMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMembershipRecord;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMembershipRecord.deserializeBinaryFromReader);
      msg.addMemberships(value);
      break;
    case 2:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.addIdentityRecords(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailedIdentityIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.InviteOrganizationMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.InviteOrganizationMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMembershipRecord.serializeBinaryToWriter
    );
  }
  f = message.getIdentityRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
  f = message.getFailedIdentityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated OrganizationMembershipRecord memberships = 1;
 * @return {!Array<!proto.OrganizationMembershipRecord>}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.getMembershipsList = function() {
  return /** @type{!Array<!proto.OrganizationMembershipRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, organization_membership_proto_pb.OrganizationMembershipRecord, 1));
};


/**
 * @param {!Array<!proto.OrganizationMembershipRecord>} value
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
*/
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.setMembershipsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.OrganizationMembershipRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.OrganizationMembershipRecord}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.addMemberships = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.OrganizationMembershipRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.clearMembershipsList = function() {
  return this.setMembershipsList([]);
};


/**
 * repeated IdentityRecord identity_records = 2;
 * @return {!Array<!proto.IdentityRecord>}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.getIdentityRecordsList = function() {
  return /** @type{!Array<!proto.IdentityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, identity_record_proto_pb.IdentityRecord, 2));
};


/**
 * @param {!Array<!proto.IdentityRecord>} value
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
*/
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.setIdentityRecordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.IdentityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IdentityRecord}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.addIdentityRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.IdentityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.clearIdentityRecordsList = function() {
  return this.setIdentityRecordsList([]);
};


/**
 * repeated string failed_identity_ids = 3;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.getFailedIdentityIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.setFailedIdentityIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.addFailedIdentityIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.InviteOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.InviteOrganizationMembersResponse.prototype.clearFailedIdentityIdsList = function() {
  return this.setFailedIdentityIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveOrganizationMembersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityRecordsList: jspb.Message.toObjectList(msg.getIdentityRecordsList(),
    identity_record_proto_pb.IdentityRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersRequest}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveOrganizationMembersRequest;
  return proto.somewear.api.v1.RemoveOrganizationMembersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersRequest}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.addIdentityRecords(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveOrganizationMembersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated IdentityRecord identity_records = 1;
 * @return {!Array<!proto.IdentityRecord>}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.getIdentityRecordsList = function() {
  return /** @type{!Array<!proto.IdentityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {!Array<!proto.IdentityRecord>} value
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersRequest} returns this
*/
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.setIdentityRecordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.IdentityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IdentityRecord}
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.addIdentityRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.IdentityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersRequest} returns this
 */
proto.somewear.api.v1.RemoveOrganizationMembersRequest.prototype.clearIdentityRecordsList = function() {
  return this.setIdentityRecordsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveOrganizationMembersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membershipsList: jspb.Message.toObjectList(msg.getMembershipsList(),
    organization_membership_proto_pb.OrganizationMembershipRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersResponse}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveOrganizationMembersResponse;
  return proto.somewear.api.v1.RemoveOrganizationMembersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersResponse}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMembershipRecord;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMembershipRecord.deserializeBinaryFromReader);
      msg.addMemberships(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveOrganizationMembersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveOrganizationMembersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMembershipRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrganizationMembershipRecord memberships = 1;
 * @return {!Array<!proto.OrganizationMembershipRecord>}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.getMembershipsList = function() {
  return /** @type{!Array<!proto.OrganizationMembershipRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, organization_membership_proto_pb.OrganizationMembershipRecord, 1));
};


/**
 * @param {!Array<!proto.OrganizationMembershipRecord>} value
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersResponse} returns this
*/
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.setMembershipsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.OrganizationMembershipRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.OrganizationMembershipRecord}
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.addMemberships = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.OrganizationMembershipRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.RemoveOrganizationMembersResponse} returns this
 */
proto.somewear.api.v1.RemoveOrganizationMembersResponse.prototype.clearMembershipsList = function() {
  return this.setMembershipsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest}
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.JoinOrganizationWorkspaceRequest;
  return proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest}
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.JoinOrganizationWorkspaceRequest} returns this
 */
proto.somewear.api.v1.JoinOrganizationWorkspaceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest}
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationDeviceUsageRequest;
  return proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest}
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetOrganizationDeviceUsageRequest} returns this
 */
proto.somewear.api.v1.GetOrganizationDeviceUsageRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest;
  return proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataUsageList: jspb.Message.toObjectList(msg.getDataUsageList(),
    api_device_pb.GetDeviceUsageResponse.toObject, includeInstance),
usageEventsList: jspb.Message.toObjectList(msg.getUsageEventsList(),
    api_device_pb.DeviceUsageEventResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse;
  return proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new api_device_pb.GetDeviceUsageResponse;
      reader.readMessage(value,api_device_pb.GetDeviceUsageResponse.deserializeBinaryFromReader);
      msg.addDataUsage(value);
      break;
    case 2:
      var value = new api_device_pb.DeviceUsageEventResponse;
      reader.readMessage(value,api_device_pb.DeviceUsageEventResponse.deserializeBinaryFromReader);
      msg.addUsageEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataUsageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      api_device_pb.GetDeviceUsageResponse.serializeBinaryToWriter
    );
  }
  f = message.getUsageEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      api_device_pb.DeviceUsageEventResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GetDeviceUsageResponse data_usage = 1;
 * @return {!Array<!proto.somewear.api.v1.GetDeviceUsageResponse>}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.getDataUsageList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.GetDeviceUsageResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, api_device_pb.GetDeviceUsageResponse, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.GetDeviceUsageResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.setDataUsageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.GetDeviceUsageResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.addDataUsage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.GetDeviceUsageResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.clearDataUsageList = function() {
  return this.setDataUsageList([]);
};


/**
 * repeated DeviceUsageEventResponse usage_events = 2;
 * @return {!Array<!proto.somewear.api.v1.DeviceUsageEventResponse>}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.getUsageEventsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.DeviceUsageEventResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, api_device_pb.DeviceUsageEventResponse, 2));
};


/**
 * @param {!Array<!proto.somewear.api.v1.DeviceUsageEventResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.setUsageEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.somewear.api.v1.DeviceUsageEventResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse}
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.addUsageEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.somewear.api.v1.DeviceUsageEventResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationDataUsageForDevicesResponse.prototype.clearUsageEventsList = function() {
  return this.setUsageEventsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationTakServerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
port: jspb.Message.getFieldWithDefault(msg, 3, 0),
serverCert: msg.getServerCert_asB64(),
serverCertPassword: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
clientCert: msg.getClientCert_asB64(),
clientCertPassword: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
beamAuth: (f = msg.getBeamAuth()) && proto.somewear.api.v1.CreateBeamAuthRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationTakServerRequest;
  return proto.somewear.api.v1.CreateOrganizationTakServerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPort(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setServerCert(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerCertPassword(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setClientCert(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientCertPassword(value);
      break;
    case 8:
      var value = new proto.somewear.api.v1.CreateBeamAuthRequest;
      reader.readMessage(value,proto.somewear.api.v1.CreateBeamAuthRequest.deserializeBinaryFromReader);
      msg.setBeamAuth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationTakServerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBeamAuth();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.somewear.api.v1.CreateBeamAuthRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 port = 3;
 * @return {number}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes server_cert = 4;
 * @return {!(string|Uint8Array)}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getServerCert = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes server_cert = 4;
 * This is a type-conversion wrapper around `getServerCert()`
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getServerCert_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getServerCert()));
};


/**
 * optional bytes server_cert = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getServerCert()`
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getServerCert_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getServerCert()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setServerCert = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.clearServerCert = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.hasServerCert = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string server_cert_password = 5;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getServerCertPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setServerCertPassword = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.clearServerCertPassword = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.hasServerCertPassword = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bytes client_cert = 6;
 * @return {!(string|Uint8Array)}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getClientCert = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes client_cert = 6;
 * This is a type-conversion wrapper around `getClientCert()`
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getClientCert_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getClientCert()));
};


/**
 * optional bytes client_cert = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getClientCert()`
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getClientCert_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getClientCert()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setClientCert = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.clearClientCert = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.hasClientCert = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string client_cert_password = 7;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getClientCertPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setClientCertPassword = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.clearClientCertPassword = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.hasClientCertPassword = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional CreateBeamAuthRequest beam_auth = 8;
 * @return {?proto.somewear.api.v1.CreateBeamAuthRequest}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.getBeamAuth = function() {
  return /** @type{?proto.somewear.api.v1.CreateBeamAuthRequest} */ (
    jspb.Message.getWrapperField(this, proto.somewear.api.v1.CreateBeamAuthRequest, 8));
};


/**
 * @param {?proto.somewear.api.v1.CreateBeamAuthRequest|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
*/
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.setBeamAuth = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationTakServerRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.clearBeamAuth = function() {
  return this.setBeamAuth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationTakServerRequest.prototype.hasBeamAuth = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateBeamAuthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateBeamAuthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateBeamAuthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
username: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateBeamAuthRequest}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateBeamAuthRequest;
  return proto.somewear.api.v1.CreateBeamAuthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateBeamAuthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateBeamAuthRequest}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateBeamAuthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateBeamAuthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateBeamAuthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateBeamAuthRequest} returns this
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateBeamAuthRequest} returns this
 */
proto.somewear.api.v1.CreateBeamAuthRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationIntegrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
integration: (f = msg.getIntegration()) && integration_proto_pb.IntegrationResponse.toObject(includeInstance, f),
beamAuth: (f = msg.getBeamAuth()) && proto.somewear.api.v1.CreateBeamAuthRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationIntegrationRequest;
  return proto.somewear.api.v1.CreateOrganizationIntegrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new integration_proto_pb.IntegrationResponse;
      reader.readMessage(value,integration_proto_pb.IntegrationResponse.deserializeBinaryFromReader);
      msg.setIntegration(value);
      break;
    case 2:
      var value = new proto.somewear.api.v1.CreateBeamAuthRequest;
      reader.readMessage(value,proto.somewear.api.v1.CreateBeamAuthRequest.deserializeBinaryFromReader);
      msg.setBeamAuth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationIntegrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      integration_proto_pb.IntegrationResponse.serializeBinaryToWriter
    );
  }
  f = message.getBeamAuth();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.somewear.api.v1.CreateBeamAuthRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional IntegrationResponse integration = 1;
 * @return {?proto.IntegrationResponse}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.getIntegration = function() {
  return /** @type{?proto.IntegrationResponse} */ (
    jspb.Message.getWrapperField(this, integration_proto_pb.IntegrationResponse, 1));
};


/**
 * @param {?proto.IntegrationResponse|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} returns this
*/
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.setIntegration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.clearIntegration = function() {
  return this.setIntegration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.hasIntegration = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CreateBeamAuthRequest beam_auth = 2;
 * @return {?proto.somewear.api.v1.CreateBeamAuthRequest}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.getBeamAuth = function() {
  return /** @type{?proto.somewear.api.v1.CreateBeamAuthRequest} */ (
    jspb.Message.getWrapperField(this, proto.somewear.api.v1.CreateBeamAuthRequest, 2));
};


/**
 * @param {?proto.somewear.api.v1.CreateBeamAuthRequest|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} returns this
*/
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.setBeamAuth = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.clearBeamAuth = function() {
  return this.setBeamAuth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationRequest.prototype.hasBeamAuth = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationIntegrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
integrationIdentity: (f = msg.getIntegrationIdentity()) && identity_record_proto_pb.IdentityRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationIntegrationResponse;
  return proto.somewear.api.v1.CreateOrganizationIntegrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.setIntegrationIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationIntegrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegrationIdentity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional IdentityRecord integration_identity = 1;
 * @return {?proto.IdentityRecord}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.getIntegrationIdentity = function() {
  return /** @type{?proto.IdentityRecord} */ (
    jspb.Message.getWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {?proto.IdentityRecord|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse} returns this
*/
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.setIntegrationIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationIntegrationResponse} returns this
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.clearIntegrationIdentity = function() {
  return this.setIntegrationIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationIntegrationResponse.prototype.hasIntegrationIdentity = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveOrganizationIntegrationRequest;
  return proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationRequest} returns this
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationRequest.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
membership: (f = msg.getMembership()) && organization_membership_proto_pb.OrganizationMembershipRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.RemoveOrganizationIntegrationResponse;
  return proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new organization_membership_proto_pb.OrganizationMembershipRecord;
      reader.readMessage(value,organization_membership_proto_pb.OrganizationMembershipRecord.deserializeBinaryFromReader);
      msg.setMembership(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembership();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      organization_membership_proto_pb.OrganizationMembershipRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationMembershipRecord membership = 1;
 * @return {?proto.OrganizationMembershipRecord}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.getMembership = function() {
  return /** @type{?proto.OrganizationMembershipRecord} */ (
    jspb.Message.getWrapperField(this, organization_membership_proto_pb.OrganizationMembershipRecord, 1));
};


/**
 * @param {?proto.OrganizationMembershipRecord|undefined} value
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse} returns this
*/
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.setMembership = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.RemoveOrganizationIntegrationResponse} returns this
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.clearMembership = function() {
  return this.setMembership(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.RemoveOrganizationIntegrationResponse.prototype.hasMembership = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationResourceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceRequest}
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationResourceRequest;
  return proto.somewear.api.v1.CreateOrganizationResourceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceRequest}
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationResourceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationResourceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationResourceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
identity: (f = msg.getIdentity()) && identity_record_proto_pb.IdentityRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceResponse}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationResourceResponse;
  return proto.somewear.api.v1.CreateOrganizationResourceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceResponse}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationResourceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationResourceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional IdentityRecord identity = 1;
 * @return {?proto.IdentityRecord}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.getIdentity = function() {
  return /** @type{?proto.IdentityRecord} */ (
    jspb.Message.getWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {?proto.IdentityRecord|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceResponse} returns this
*/
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.setIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationResourceResponse} returns this
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationResourceResponse.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationApiClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientRequest}
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationApiClientRequest;
  return proto.somewear.api.v1.CreateOrganizationApiClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientRequest}
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationApiClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientRequest} returns this
 */
proto.somewear.api.v1.CreateOrganizationApiClientRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateOrganizationApiClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
apiClient: (f = msg.getApiClient()) && api_client_record_proto_pb.ApiClientResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientResponse}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateOrganizationApiClientResponse;
  return proto.somewear.api.v1.CreateOrganizationApiClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientResponse}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new api_client_record_proto_pb.ApiClientResponse;
      reader.readMessage(value,api_client_record_proto_pb.ApiClientResponse.deserializeBinaryFromReader);
      msg.setApiClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateOrganizationApiClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateOrganizationApiClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      api_client_record_proto_pb.ApiClientResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional ApiClientResponse api_client = 1;
 * @return {?proto.ApiClientResponse}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.getApiClient = function() {
  return /** @type{?proto.ApiClientResponse} */ (
    jspb.Message.getWrapperField(this, api_client_record_proto_pb.ApiClientResponse, 1));
};


/**
 * @param {?proto.ApiClientResponse|undefined} value
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientResponse} returns this
*/
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.setApiClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateOrganizationApiClientResponse} returns this
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.clearApiClient = function() {
  return this.setApiClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateOrganizationApiClientResponse.prototype.hasApiClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeleteOrganizationApiClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
apiClientId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeleteOrganizationApiClientRequest;
  return proto.somewear.api.v1.DeleteOrganizationApiClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiClientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeleteOrganizationApiClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string api_client_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.prototype.getApiClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientRequest} returns this
 */
proto.somewear.api.v1.DeleteOrganizationApiClientRequest.prototype.setApiClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeleteOrganizationApiClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
apiClient: (f = msg.getApiClient()) && api_client_record_proto_pb.ApiClientResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeleteOrganizationApiClientResponse;
  return proto.somewear.api.v1.DeleteOrganizationApiClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new api_client_record_proto_pb.ApiClientResponse;
      reader.readMessage(value,api_client_record_proto_pb.ApiClientResponse.deserializeBinaryFromReader);
      msg.setApiClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeleteOrganizationApiClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      api_client_record_proto_pb.ApiClientResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional ApiClientResponse api_client = 1;
 * @return {?proto.ApiClientResponse}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.getApiClient = function() {
  return /** @type{?proto.ApiClientResponse} */ (
    jspb.Message.getWrapperField(this, api_client_record_proto_pb.ApiClientResponse, 1));
};


/**
 * @param {?proto.ApiClientResponse|undefined} value
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse} returns this
*/
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.setApiClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.DeleteOrganizationApiClientResponse} returns this
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.clearApiClient = function() {
  return this.setApiClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.DeleteOrganizationApiClientResponse.prototype.hasApiClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationApiClientsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsRequest}
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationApiClientsRequest;
  return proto.somewear.api.v1.GetOrganizationApiClientsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsRequest}
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationApiClientsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationApiClientsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationApiClientsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
apiClientsList: jspb.Message.toObjectList(msg.getApiClientsList(),
    api_client_record_proto_pb.ApiClientResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsResponse}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationApiClientsResponse;
  return proto.somewear.api.v1.GetOrganizationApiClientsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsResponse}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new api_client_record_proto_pb.ApiClientResponse;
      reader.readMessage(value,api_client_record_proto_pb.ApiClientResponse.deserializeBinaryFromReader);
      msg.addApiClients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationApiClientsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationApiClientsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiClientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      api_client_record_proto_pb.ApiClientResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ApiClientResponse api_clients = 1;
 * @return {!Array<!proto.ApiClientResponse>}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.getApiClientsList = function() {
  return /** @type{!Array<!proto.ApiClientResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, api_client_record_proto_pb.ApiClientResponse, 1));
};


/**
 * @param {!Array<!proto.ApiClientResponse>} value
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.setApiClientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ApiClientResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ApiClientResponse}
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.addApiClients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ApiClientResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationApiClientsResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationApiClientsResponse.prototype.clearApiClientsList = function() {
  return this.setApiClientsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
enableIntegration: (f = msg.getEnableIntegration()) && proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.toObject(includeInstance, f),
enableWorkspaceIntegrationsList: jspb.Message.toObjectList(msg.getEnableWorkspaceIntegrationsList(),
    proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.toObject, includeInstance),
resourceWorkspaceMappingChangesList: jspb.Message.toObjectList(msg.getResourceWorkspaceMappingChangesList(),
    proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest;
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration;
      reader.readMessage(value,proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.deserializeBinaryFromReader);
      msg.setEnableIntegration(value);
      break;
    case 2:
      var value = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount;
      reader.readMessage(value,proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.deserializeBinaryFromReader);
      msg.addEnableWorkspaceIntegrations(value);
      break;
    case 3:
      var value = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace;
      reader.readMessage(value,proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.deserializeBinaryFromReader);
      msg.addResourceWorkspaceMappingChanges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnableIntegration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.serializeBinaryToWriter
    );
  }
  f = message.getEnableWorkspaceIntegrationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.serializeBinaryToWriter
    );
  }
  f = message.getResourceWorkspaceMappingChangesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
inboundEnabled: jspb.Message.getFieldWithDefault(msg, 2, 0),
outboundEnabled: jspb.Message.getFieldWithDefault(msg, 3, 0),
defaultWorkspaceId: jspb.Message.getFieldWithDefault(msg, 4, ""),
addFutureWorkspaces: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration;
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setInboundEnabled(value);
      break;
    case 3:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setOutboundEnabled(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultWorkspaceId(value);
      break;
    case 5:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setAddFutureWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInboundEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOutboundEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDefaultWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddFutureWorkspaces();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OptionalBool inbound_enabled = 2;
 * @return {!proto.OptionalBool}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.getInboundEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.setInboundEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional OptionalBool outbound_enabled = 3;
 * @return {!proto.OptionalBool}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.getOutboundEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.setOutboundEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string default_workspace_id = 4;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.getDefaultWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.setDefaultWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional OptionalBool add_future_workspaces = 5;
 * @return {!proto.OptionalBool}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.getAddFutureWorkspaces = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration.prototype.setAddFutureWorkspaces = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
inboundEnabled: jspb.Message.getFieldWithDefault(msg, 3, 0),
outboundEnabled: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount;
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setInboundEnabled(value);
      break;
    case 4:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setOutboundEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInboundEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOutboundEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional OptionalBool inbound_enabled = 3;
 * @return {!proto.OptionalBool}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.getInboundEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.setInboundEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional OptionalBool outbound_enabled = 4;
 * @return {!proto.OptionalBool}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.getOutboundEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount.prototype.setOutboundEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
workspaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace;
  return proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional EnableIntegration enable_integration = 1;
 * @return {?proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.getEnableIntegration = function() {
  return /** @type{?proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration} */ (
    jspb.Message.getWrapperField(this, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration, 1));
};


/**
 * @param {?proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegration|undefined} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
*/
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.setEnableIntegration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.clearEnableIntegration = function() {
  return this.setEnableIntegration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.hasEnableIntegration = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated EnableIntegrationAccount enable_workspace_integrations = 2;
 * @return {!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount>}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.getEnableWorkspaceIntegrationsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount, 2));
};


/**
 * @param {!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount>} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
*/
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.setEnableWorkspaceIntegrationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.addEnableWorkspaceIntegrations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.EnableIntegrationAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.clearEnableWorkspaceIntegrationsList = function() {
  return this.setEnableWorkspaceIntegrationsList([]);
};


/**
 * repeated UpdateTakResourceAssignedWorkspace resource_workspace_mapping_changes = 3;
 * @return {!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace>}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.getResourceWorkspaceMappingChangesList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace, 3));
};


/**
 * @param {!Array<!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace>} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
*/
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.setResourceWorkspaceMappingChangesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace}
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.addResourceWorkspaceMappingChanges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.UpdateTakResourceAssignedWorkspace, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationIntegrationRoutingRequest.prototype.clearResourceWorkspaceMappingChangesList = function() {
  return this.setResourceWorkspaceMappingChangesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest;
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.toObject, includeInstance),
identitiesList: jspb.Message.toObjectList(msg.getIdentitiesList(),
    proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse;
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount;
      reader.readMessage(value,proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 2:
      var value = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity;
      reader.readMessage(value,proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.deserializeBinaryFromReader);
      msg.addIdentities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.serializeBinaryToWriter
    );
  }
  f = message.getIdentitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
account: (f = msg.getAccount()) && user_proto_pb.UserResponse.toObject(includeInstance, f),
inboundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
outboundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
inboundLastUpdated: (f = msg.getInboundLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
outboundLastUpdated: (f = msg.getOutboundLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount;
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_proto_pb.UserResponse;
      reader.readMessage(value,user_proto_pb.UserResponse.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInboundEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOutboundEnabled(value);
      break;
    case 4:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setInboundLastUpdated(value);
      break;
    case 5:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOutboundLastUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_proto_pb.UserResponse.serializeBinaryToWriter
    );
  }
  f = message.getInboundEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOutboundEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getInboundLastUpdated();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOutboundLastUpdated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserResponse account = 1;
 * @return {?proto.UserResponse}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.getAccount = function() {
  return /** @type{?proto.UserResponse} */ (
    jspb.Message.getWrapperField(this, user_proto_pb.UserResponse, 1));
};


/**
 * @param {?proto.UserResponse|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool inbound_enabled = 2;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.getInboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.setInboundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool outbound_enabled = 3;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.getOutboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.setOutboundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Timestamp inbound_last_updated = 4;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.getInboundLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 4));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.setInboundLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.clearInboundLastUpdated = function() {
  return this.setInboundLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.hasInboundLastUpdated = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Timestamp outbound_last_updated = 5;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.getOutboundLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 5));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.setOutboundLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.clearOutboundLastUpdated = function() {
  return this.setOutboundLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount.prototype.hasOutboundLastUpdated = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.toObject = function(includeInstance, msg) {
  var f, obj = {
identity: (f = msg.getIdentity()) && identity_record_proto_pb.IdentityRecord.toObject(includeInstance, f),
inboundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
outboundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
beamEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
integrationType: jspb.Message.getFieldWithDefault(msg, 5, 0),
defaultWorkspaceId: jspb.Message.getFieldWithDefault(msg, 6, ""),
inboundLastUpdated: (f = msg.getInboundLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
outboundLastUpdated: (f = msg.getOutboundLastUpdated()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
lastConnected: (f = msg.getLastConnected()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
lastDisconnected: (f = msg.getLastDisconnected()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
addFutureWorkspaces: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity;
  return proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInboundEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOutboundEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBeamEnabled(value);
      break;
    case 5:
      var value = /** @type {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType} */ (reader.readEnum());
      msg.setIntegrationType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultWorkspaceId(value);
      break;
    case 7:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setInboundLastUpdated(value);
      break;
    case 8:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOutboundLastUpdated(value);
      break;
    case 9:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastConnected(value);
      break;
    case 10:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastDisconnected(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddFutureWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
  f = message.getInboundEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOutboundEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getBeamEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIntegrationType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDefaultWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInboundLastUpdated();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOutboundLastUpdated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastConnected();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastDisconnected();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAddFutureWorkspaces();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType = {
  NONE: 0,
  TAK: 1,
  WEBHOOK: 2,
  OPENAI: 3,
  FEDERATED_TAK: 4
};

/**
 * optional IdentityRecord identity = 1;
 * @return {?proto.IdentityRecord}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getIdentity = function() {
  return /** @type{?proto.IdentityRecord} */ (
    jspb.Message.getWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {?proto.IdentityRecord|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool inbound_enabled = 2;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getInboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setInboundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool outbound_enabled = 3;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getOutboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setOutboundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool beam_enabled = 4;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getBeamEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setBeamEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional IntegrationType integration_type = 5;
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getIntegrationType = function() {
  return /** @type {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setIntegrationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string default_workspace_id = 6;
 * @return {string}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getDefaultWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setDefaultWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Timestamp inbound_last_updated = 7;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getInboundLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 7));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setInboundLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.clearInboundLastUpdated = function() {
  return this.setInboundLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.hasInboundLastUpdated = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Timestamp outbound_last_updated = 8;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getOutboundLastUpdated = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 8));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setOutboundLastUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.clearOutboundLastUpdated = function() {
  return this.setOutboundLastUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.hasOutboundLastUpdated = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Timestamp last_connected = 9;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getLastConnected = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 9));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setLastConnected = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.clearLastConnected = function() {
  return this.setLastConnected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.hasLastConnected = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Timestamp last_disconnected = 10;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getLastDisconnected = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 10));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setLastDisconnected = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.clearLastDisconnected = function() {
  return this.setLastDisconnected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.hasLastDisconnected = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool add_future_workspaces = 11;
 * @return {boolean}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.getAddFutureWorkspaces = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.prototype.setAddFutureWorkspaces = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * repeated IntegrationAccount accounts = 1;
 * @return {!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount>}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount>} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * repeated IntegrationIdentity identities = 2;
 * @return {!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity>}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.getIdentitiesList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity, 2));
};


/**
 * @param {!Array<!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity>} value
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} returns this
*/
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.setIdentitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity}
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.addIdentities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.IntegrationIdentity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse} returns this
 */
proto.somewear.api.v1.GetOrganizationIntegrationAccountsResponse.prototype.clearIdentitiesList = function() {
  return this.setIdentitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationClaimCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest;
  return proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationClaimCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationClaimCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string organization_claim_code = 1;
 * @return {string}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.prototype.getOrganizationClaimCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest} returns this
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeRequest.prototype.setOrganizationClaimCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse;
  return proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse} returns this
 */
proto.somewear.api.v1.ConfirmOrganizationClaimCodeResponse.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ClaimOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ClaimOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ClaimOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationClaimCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ClaimOrganizationRequest}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ClaimOrganizationRequest;
  return proto.somewear.api.v1.ClaimOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ClaimOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ClaimOrganizationRequest}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationClaimCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ClaimOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ClaimOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ClaimOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationClaimCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string organization_claim_code = 1;
 * @return {string}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.getOrganizationClaimCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ClaimOrganizationRequest} returns this
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.setOrganizationClaimCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string organization_name = 2;
 * @return {string}
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.getOrganizationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ClaimOrganizationRequest} returns this
 */
proto.somewear.api.v1.ClaimOrganizationRequest.prototype.setOrganizationName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.SendCotToTakServerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.SendCotToTakServerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SendCotToTakServerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cot: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.SendCotToTakServerRequest}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.SendCotToTakServerRequest;
  return proto.somewear.api.v1.SendCotToTakServerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.SendCotToTakServerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.SendCotToTakServerRequest}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.SendCotToTakServerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.SendCotToTakServerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SendCotToTakServerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCot();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.SendCotToTakServerRequest} returns this
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cot = 2;
 * @return {string}
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.getCot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.SendCotToTakServerRequest} returns this
 */
proto.somewear.api.v1.SendCotToTakServerRequest.prototype.setCot = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.SendCotToTakServerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.SendCotToTakServerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.SendCotToTakServerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SendCotToTakServerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.SendCotToTakServerResponse}
 */
proto.somewear.api.v1.SendCotToTakServerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.SendCotToTakServerResponse;
  return proto.somewear.api.v1.SendCotToTakServerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.SendCotToTakServerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.SendCotToTakServerResponse}
 */
proto.somewear.api.v1.SendCotToTakServerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.SendCotToTakServerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.SendCotToTakServerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.SendCotToTakServerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SendCotToTakServerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
newPassword: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest;
  return proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string identity_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.getIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_password = 2;
 * @return {string}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest} returns this
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordRequest.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse;
  return proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UpdateOrganizationMemberPasswordResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.somewear.api.v1);
